import * as React from 'react';

import { connect } from 'react-redux';

import styled, { css } from 'styled-components';

import AppState from '@webapp/store/state';
import { motion } from 'framer-motion';

export interface BackdropProps {
  className?: string;
  showBackdrop: boolean;
  isMenuOutside?: boolean;
  onClick: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const mapStateToProps = (state: AppState) => ({
  showBackdrop: state.ui.showBackdrop,
});

export const Backdrop: React.FC<BackdropProps> = (props) => {
  return (
    <motion.span
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{
        opacity: props.showBackdrop ? 0.3 : 0,
        transition: {
          ease: [0.0, 0.0, 0.25, 1.0],
        },
      }}
      className={props.className}
      {...props}
    />
  );
};

export default connect(mapStateToProps)(styled(Backdrop)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  background: ${({ theme }) => theme.colors.black};

  ${(props) =>
    props.showBackdrop
      ? css`
          pointer-events: all;
          z-index: ${({ theme }) => theme.zIndices.underHeader};
          @media ${({ theme }) => theme.device.tablet} {
            z-index: ${({ theme }) => theme.zIndices.header};
          }
        `
      : null}

  ${(props) =>
    props.isMenuOutside
      ? css`
          z-index: ${({ theme }) => theme.zIndices.header};
        `
      : null}
`);
